import * as React from 'react';

import classnames from 'classnames';

import {ArchiveRegularIcon} from '../icon/svg/archive-regular-icon';
import {IconTabs} from '../tabs/icon-tabs/icon-tabs';

export type Tab = {
    id: string;
    label?: string;
    icon: React.ComponentType<any> | string;
    href?: string;
    component?: React.ReactNode;
    onClick?: () => void;
};

type TabProps = {
    options: Tab[];
    selectedTab: string;
    onChangeTab?: (newTab: string) => void;
};

type ArchiveTab = {
    isActive: boolean;
    onChange: () => void;
};

type Props = {
    tabs?: TabProps;
    leftSection?: React.ReactNode;
    archiveTab?: ArchiveTab;
    noVerticalPadding?: boolean;
};

export function ListPageControlBar(props: Props) {
    const controlBarStyles = classnames(
        'flex flex-shrink px-16 border-bottom background-white justify-sb align-center',
        {
            'py-8': !props.noVerticalPadding,
        }
    );

    return (
        <div className={controlBarStyles}>
            <div className='flex align-center'>
                {props.leftSection ? props.leftSection : undefined}
            </div>
            {(props.tabs || props.archiveTab) && (
                <Tabs tabs={props.tabs} archiveTab={props.archiveTab} />
            )}
        </div>
    );
}

type TabsProps = {
    tabs?: TabProps;
    archiveTab?: ArchiveTab;
};

function Tabs(props: TabsProps) {
    const isArchived = props.archiveTab && props.archiveTab.isActive;

    const viewTabs = props.tabs
        ? props.tabs.options.map((tab) => ({
              id: tab.id,
              label: tab.label,
              Icon: tab.icon,
              isActive: Boolean(props.tabs && props.tabs.selectedTab === tab.id && !isArchived),
              href: tab.href,
          }))
        : [];

    const tabOptions = props.archiveTab
        ? [
              ...viewTabs,
              {
                  id: 'archive',
                  label: 'Archived',
                  Icon: ArchiveRegularIcon,
                  isActive: props.archiveTab.isActive,
                  onClick: props.archiveTab.onChange,
              },
          ]
        : viewTabs;

    return <IconTabs tabs={tabOptions} />;
}
